/// <reference types="angular" />
/// <reference types="angular-cookies" />

import * as angular from "angular";

import "angular-cookies";
import "isomorphic-fetch";
import * as jwt from "jwt-decode"
import * as cognito from "amazon-cognito-identity-js";
import { CognitoAuth } from 'amazon-cognito-auth-js';
import * as $ from "jquery"; 
import * as _ from "lodash";

export class BaseModel {
	private accessTokenKey: string = 'accessToken';
	private accessTokenExpirationKey: string = 'accessTokenExpiration';

	public storage: Storage = this.$window.sessionStorage;

	public appTrayPinnedStorageKey: string = "AppTrayPinned";
	public AC_App360: number = 1;
	public AC_SolarPV: number = 2;
	public AC_MATSLite: number = 3;
	public AC_PGAnalyst: number = 4;
	public AC_EvrnDshbd: number = 5;
	public AC_CSAPR: number = 6;
	public AC_ProjPrior: number = 7;
	public AC_ScenarioPlanner: number = 8;
	public AC_APPerfAnalyst: number = 9;
	public AC_RegAdmin: number = 10;
	public AC_ScenarioMonitor: number = 11;
	public AC_SystemHealth: number = 12;
	public AC_WaterCHP: number = 13;
	public AC_WaterMeter: number = 14;
	public AC_WaterReclamation: number = 15;
	public AC_ArcFlash: number = 16;
	public AC_IssuesManagement: number = 17;
	public AC_WaterTreatment: number = 18;
	public AC_Microgrid: number = 19;
	public AC_InvestmentAccel: number = 20;
	public AC_UserAdmin: number = 21;
	public AC_Alerts: number = 22;
	public AC_IssuesManagementPerformanceAnalyst: number = 31;
	public AC_OptionsExplorer: number = 34;
	public AC_RiskMatrix: number = 35;
	public AC_BI: number = 36;
	public AC_SmartES: number = 37;
	public AC_SmartDG: number = 39
    public AC_AssetExplorer: number = 41;
    public AC_ProgramNavigator: number = 42;
    public AC_ProcessDataUploadUtility: number = 43;
    public AC_WaterQualityPlatform: number = 46;
    public AC_CriteriaObjectUtility: number = 50;
	public AC_WorkManagement: number = 51;
	public AC_RiskAssessment: number = 52;
	public AC_WasteWater: number = 53;
	public AC_Monitor: number = 54;
	public AC_Inform: number = 55;
	public AC_AssetDataManagement: number = 56;
	public AC_CurrentSituation: number = 57;
	public AC_Trends: number = 58;
	public AC_Scorecards: number = 59;
	public AC_Views: number = 60;

	constructor(private $window: ng.IWindowService, private $http: ng.IHttpService, private $cookies: angular.cookies.ICookiesService, private atonixAuthenticationService: AtonixAuthenticationService, private $q: ng.IQService, private $log: angular.ILogService) {
		this.reinitialize();
	}

	public getCookie(cname: string) {
		return this.$cookies.get(cname);
	}

	public setCookie(cname, cvalue, exdays) {
		var options: angular.cookies.ICookiesOptions;
		if (exdays) {
			var d = new Date();
			d.setDate(d.getDate() + exdays);
			options = { expires: d };
		}
		this.$cookies.put(cname, cvalue, options);
	}

	public deleteCookie(cname) {
		this.$cookies.remove(cname);
	}

	public setStorageToLocal() {
		this.storage = this.$window.localStorage;
	}

	public setStorageToSession() {
		this.storage = this.$window.sessionStorage;
	}

	public SessionStorage = this.$window.sessionStorage;
	public LocalStorage = this.$window.localStorage;

	private server: string = '/Services';

	public reinitialize() {
		//Need to know whether to use local storage or session storage for the token.
		//If the token is in local storage then the app should use local storage.  If not then
		//either the user is not logged in or the app should use session storage.
		if (this.$window.localStorage[this.accessTokenKey]) {
			this.setStorageToLocal();
		}
		else {
			this.setStorageToSession();
		}


		//This is the bearer token used for authentication.  It should be automatically applied to all
		//web service calls.
		this.applyAccessToken();
	}

	public applyAccessToken() {
        //Time difference between client and UTC in minutess
        //+ if local timezone is ahead of UTC
        //- if local timezone is behind UTC
        var offsetStd = -(new Date(new Date().getFullYear(), 0, 1)).getTimezoneOffset(); //Time zone offset during standard time
        var offsetDst = -(new Date(new Date().getFullYear(), 6, 1)).getTimezoneOffset(); //Time zone offset during daylight time (if applicable)
        this.$http.defaults.headers.common['TimezoneOffsetStd'] = String(offsetStd);
        this.$http.defaults.headers.common['TimezoneOffsetDst'] = String(offsetDst);

	}

	public clearCachedUser() {
		if (this.storage[this.userKey]) {
			this.storage.removeItem(this.userKey);
		}
    }

    public clearCacheKeyContaining(strKey: string) {
        for (var key in this.storage) {
            if (key.toString().indexOf(strKey) >= 0) {
                delete this.storage[key];
            }
        }
    }

	private userKey: string = 'user';
	public localUser(myUser?: model.IUser) {
		var result: model.IUser = null;
		if (angular.isDefined(myUser)) {
			this.storage[this.userKey] = angular.toJson(myUser);
		}
		var u: string = this.storage[this.userKey];
		if (u === 'null') {
			u = null;
		}
		if (u) {
			result = angular.fromJson(u);
		}
		if (this.$window['appInsights'] && this.$window['appInsights'].setAuthenticatedUserContext && result && result.Email) {
			this.$window['appInsights'].setAuthenticatedUserContext(result.Email.replace(/[,;=| ]+/g, "_"));
		}
		return result;
	};

	public clearAppContext() {
		delete this.$http.defaults.headers.common['AppContext'];
	}

	public setAppContext = function (ac) {
		this.$http.defaults.headers.common.AppContext = String(ac);
	}

	//This is an attempt to get the token.  The token itself if short lived and will be expired frequently. 
	//When this method is called it will update the local copy of the token.  If the token is retrieved every time
	//it is used this should work.  If you retrieve the token once and then use it repeatedly it will stop working. 
	//If this method is being used it should probably be changed to use the accessTokenPromise instead.  
	private token: string; 
	public accessToken() {
		this.atonixAuthenticationService.GetToken().then((t) => {
			this.token = t;
		});
		return this.token; 
	};

	public accessTokenPromise() {
		return this.atonixAuthenticationService.GetToken(); 
	}

	public removeLocalData() {
		delete this.$window.localStorage[this.accessTokenKey];
		delete this.$window.sessionStorage[this.accessTokenKey];

		this.$window.localStorage.clear();
		this.$window.sessionStorage.clear();
		this.storage = this.$window.sessionStorage;
	};

	//FIX ME: I don't think this is working as designed.
	public isAuthorized() {
		return true;
	};

	public getUrl(path) {
		if (path[0] !== '/') { path = '/' + path; }
		return this.server + path;
	};

	public openNew(path) {
		if (path[0] !== '/') { path = '/' + path; }
		var url = this.$window.location.host + path;
		this.$window.open(path, '_blank');
	};

	public openNewAbsolute(path) {
		this.$window.open(path, '_blank');
	};

	public openInCurrent(path) {
		if (path[0] !== '/') { path = '/' + path; }
		var url = this.$window.location.host + path;
		console.log("Setting href to :" + url);
		this.$window.location.href = path;
	};

    public getImagePath(uniqueID: string) {
        var deferred: ng.IDeferred<string> = this.$q.defer();

        this.getFileUrl(uniqueID, '', false)
            .then((link) => {
                var path = "";
                if (link.Url != null && link.Url != "") {
                    path = link.Url;
                }
                else {
                    path = this.getUrl('api/Images/File?Id=' + uniqueID + "&access_token=" + this.accessToken()).toString();
                }
                deferred.resolve(path);
            }).catch((err) => {
                this.$log.error("Model Method Error " + "GetFileUrl", JSON.stringify(err.data));
                deferred.reject(err.data);
            });
        return deferred.promise;
    };

    public getFileInfo(uniqueID: string) {
        var deferred: ng.IDeferred<model.IFileInfo> = this.$q.defer();
        this.$http.get<model.IFileInfo>(this.getUrl('api/Images/FileInfo'), {
            'params': {
                'uniqueID': uniqueID
            }
        }).then((data) => {
            data.data.Url = decodeURIComponent(data.data.Url);
            deferred.resolve(data.data);
        }).catch((err) => {
            this.$log.error("Model Method Error getFileInfo", JSON.stringify(err.data));
            deferred.reject(err.data);
        });
        return deferred.promise;
    }

	public getQuickReplyFileURL(contentID: string, fileName: string, fileType?: string) {
		var deferred: ng.IDeferred<model.IAWSFileUrl> = this.$q.defer();
		if (contentID == null)
			contentID = "";

		this.$http.get<model.IAWSFileUrl>(this.getUrl('api/Images/QuickReplyFileURL'), {
			'params': {
				'id': contentID,
				'fileName': fileName,
				'fileType': fileType
			},
			headers: {
				'Anonymous':true
			}
		}).then((data) => {
			data.data.Url = decodeURIComponent(data.data.Url);
			deferred.resolve(data.data);
		}).catch((err) => {
			this.$log.error("Model Method Error getQuickReplyFileURL", JSON.stringify(err.data));
			deferred.reject(err.data);
		});
		return deferred.promise;
	}

    public getFileUrl(contentID: string, fileName: string, upload: boolean, fileType?: string, width?: number, bucketType?: string) {
        var deferred: ng.IDeferred<model.IAWSFileUrl> = this.$q.defer();
        if (contentID == null)
            contentID = "";

        this.$http.get<model.IAWSFileUrl>(this.getUrl('api/Images/FileURL'), {
            'params': {
                'id': contentID,
                'fileName': fileName,
				'upload': upload,
				'fileType': fileType,
                'width': width,
                'bucketType': bucketType
            }
        }).then((data) => {
            data.data.Url = decodeURIComponent(data.data.Url);
            deferred.resolve(data.data);
            }).catch((err) => {
            this.$log.error("Model Method Error " + "GetFileUrl", JSON.stringify(err.data));
            deferred.reject(err.data);
        });
        return deferred.promise;
    }

    public uploadFile(uploadUrl: string, file: any) {
        var deferred: ng.IDeferred<boolean> = this.$q.defer();

        var xhr = new XMLHttpRequest();
        xhr.open("PUT", uploadUrl, true);
        (<any>xhr).msCaching = 'disabled';
		xhr.setRequestHeader('x-amz-meta-filename', file.name);
		xhr.setRequestHeader('Content-Type', file.type || "application/octet-stream" );
		//xhr.setRequestHeader('Content-Disposition', 'attachment; filename=' + file.name );
        xhr.onload = function () {
            if (xhr.status === 200) {
                deferred.resolve(true);
            }
            else {
                deferred.reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            deferred.reject({
                status: xhr.status,
                statusText: xhr.statusText
            });
        };
        xhr.send(file); // `file` is a File object here

        return deferred.promise;
    }

    public uploadJSONString(uploadUrl: string, jsonObject: any, fileName: string) {
        var deferred: ng.IDeferred<boolean> = this.$q.defer();

        var xhr = new XMLHttpRequest();
        xhr.open("PUT", uploadUrl, true);
        (<any>xhr).msCaching = 'disabled';
        xhr.setRequestHeader('x-amz-meta-filename', fileName);
        xhr.setRequestHeader('Content-Type', 'application/json');
        //xhr.setRequestHeader('Content-Disposition', 'attachment; filename=' + file.name );
        xhr.onload = function () {
            if (xhr.status === 200) {
                deferred.resolve(true);
            }
            else {
                deferred.reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            deferred.reject({
                status: xhr.status,
                statusText: xhr.statusText
            });
        };
        xhr.send(JSON.stringify(jsonObject));

        return deferred.promise;
    }


    public saveFileInfo(fileName: string, assetID: number, contentID: string, quickReply: boolean) {
        var deferred: ng.IDeferred<model.IAWSFileUrl> = this.$q.defer();
		this.$http.post<model.IAWSFileUrl>(this.getUrl('api/Images/SaveFileInfo'), null, {
			'params': {
				'fileName': fileName,
				'assetID': assetID,
				'contentID': contentID,
				'quickReply': quickReply
			},
			headers: {
				'Anonymous':true
			}
        }).then((data) => {
            data.data.Url = decodeURIComponent(data.data.Url);
            deferred.resolve(data.data);
        }).catch((err) => {
            this.$log.error("SaveFileInfo", err);
            deferred.reject(err.data);
        });
        return deferred.promise;
    }

	private axToken: ng.IPromise<model.IAXToken> | model.IAXToken = null;

	private isTokenPromise(token: ng.IPromise<model.IAXToken> | model.IAXToken): token is ng.IPromise<model.IAXToken> {
		return token && (<ng.IPromise<model.IAXToken>>token).then !== undefined;
	}
	public getAXToken() {
		if (this.isTokenPromise(this.axToken)) {
			return this.axToken;
		}
		else {
			var deferred: ng.IDeferred<model.IAXToken> = this.$q.defer();

			if (this.axToken && angular.isString((<model.IAXToken>this.axToken).ExpirationDate)) {
				var s: string = (<any>this.axToken).ExpirationDate;
				(<model.IAXToken>this.axToken).ExpirationDate = new Date(s);
			}

			if (this.axToken && (<model.IAXToken>this.axToken).ExpirationDate.getTime() > new Date().getTime()) {
				deferred.resolve(<model.IAXToken>this.axToken);
			}
			else {
				this.axToken = deferred.promise;
				this.$http.get<model.IAXToken>('/Services/api/Account/AXToken')
					.then((data) => {
						this.axToken = data.data;
						deferred.resolve(data.data);
					})
					.catch((err) => {
						this.axToken = null;
						console.error("Could not get AX Token:" + JSON.stringify(err));
						deferred.reject(err);
					});
			}

			return deferred.promise;
		}

	}
    public getFileTypeIconSource(fileNameOrExtension: string) {
        var re: RegExp = /(?:\.([^.]+))?$/;
        var extensionArray = re.exec(fileNameOrExtension);
        if (extensionArray == undefined || extensionArray == null || extensionArray.length <= 1) {
            return "/Content/file-type-icons/48px/_page.png";
        }

        var extension: string = extensionArray[1];
        switch (extension) {
            case ("avi"):
                return "/Content/file-type-icons/48px/avi.png";
            case ("bmp"):
                return "/Content/file-type-icons/48px/bmp.png";
            case ("csv"):
                return "/Content/file-type-icons/48px/csv.png";
            case ("dat"):
                return "/Content/file-type-icons/48px/dat.png";
            case ("dmg"):
                return "/Content/file-type-icons/48px/dmg.png";
            case ("doc"):
                return "/Content/file-type-icons/48px/doc.png";
            case ("docx"):
                return "/Content/file-type-icons/48px/doc.png";
            case ("dwg"):
                return "/Content/file-type-icons/48px/dwg.png";
            case ("gif"):
                return "/Content/file-type-icons/48px/gif.png";
            case ("jpg"):
                return "/Content/file-type-icons/48px/jpg.png";
            case ("jpeg"):
                return "/Content/file-type-icons/48px/jpg.png";
            case ("mp3"):
                return "/Content/file-type-icons/48px/mp3.png";
            case ("mp4"):
                return "/Content/file-type-icons/48px/mp4.png";
            case ("mpg"):
                return "/Content/file-type-icons/48px/mpg.png";
            case ("pdf"):
                return "/Content/file-type-icons/48px/pdf.png";
            case ("png"):
                return "/Content/file-type-icons/48px/png.png";
            case ("ppt"):
                return "/Content/file-type-icons/48px/ppt.png";
            case ("pptx"):
                return "/Content/file-type-icons/48px/ppt.png";
            case ("tiff"):
                return "/Content/file-type-icons/48px/tiff.png";
            case ("txt"):
                return "/Content/file-type-icons/48px/txt.png";
            case ("wav"):
                return "/Content/file-type-icons/48px/wav.png";
            case ("xls"):
                return "/Content/file-type-icons/48px/xls.png";
            case ("xlsx"):
                return "/Content/file-type-icons/48px/xlsx.png";
            case ("xlsm"):
                return "/Content/file-type-icons/48px/xls.png";
            case ("zip"):
                return "/Content/file-type-icons/48px/zip.png";
            default:
                return "/Content/file-type-icons/48px/_page.png";
        }
    }
}

export class ModelBase{
	constructor(protected path: string, protected $http: ng.IHttpService, protected $q: ng.IQService,protected $log:ng.ILogService, protected baseModel: BaseModel) {

	}

	public static ForceLoad() {

	}

	protected GetUrl(service: string) {
		return this.baseModel.getUrl(this.path +  service)
	}

	public getImagePath(uniqueID: string) {
		return this.baseModel.getImagePath(uniqueID);
    }

    public getFileInfo(uniqueID: string) {
        return this.baseModel.getFileInfo(uniqueID);
    }

	public getFileUrl(contentID: string, fileName: string, upload: boolean, fileType?: string) {
		return this.baseModel.getFileUrl(contentID, fileName, upload, fileType);
    }

    public uploadFile(uploadUrl: string, file: any) {
        return this.baseModel.uploadFile(uploadUrl, file);
    }

    public uploadJSONString(uploadUrl: string, jsonObject: any, fileName: string) {
        return this.baseModel.uploadJSONString(uploadUrl, jsonObject, fileName);
    }

    public saveFileInfo(fileName: string, assetID: number, contentID: string, quickReply: boolean) {
        return this.baseModel.saveFileInfo(fileName, assetID, contentID, quickReply);
    }

    public getFileTypeIconSource(fileNameOrExtension: string) {
        return this.baseModel.getFileTypeIconSource(fileNameOrExtension);
    }

	public toDateTime(myDate: Date) {
		if (angular.isDate(myDate)) {
			return myDate.toISOString();
		}
		else {
			return null;
		}
	}

    protected LogError(method: string, error: any) {
		try {
			if (!this.isCancelled(error)) {
				this.$log.error("Model Method Error " + method, JSON.stringify(error));
			}
        }
        catch (e)
        {
            this.$log.error("Model Method Error " + method, "");
        }
		//if (console && console.error) {
		//	console.error("Model Method Error " + method + ":" + JSON.stringify(error));
		//}
	}

	public toDateTimeOffset(myDate:Date) {
		if (angular.isDate(myDate)) {

			var month = String(myDate.getMonth() + 1);
			if (month.length == 1) { month = "0" + month; }
			var day = String(myDate.getDate());
			if (day.length == 1) { day = "0" + day; }
			var hour = String(myDate.getHours());
			if (hour.length == 1) {
				hour = "0" + hour;
			}
			var minute = String(myDate.getMinutes());
			if (minute.length == 1) {
				minute = "0" + minute;
			}
			var second = String(myDate.getSeconds());
			if (second.length == 1) {
				second = "0" + second;
			}

			var timeZoneOffset = myDate.getTimezoneOffset();
			var timeZoneHours = String(Math.floor(timeZoneOffset / 60));
			var timeZoneMinutes = String(timeZoneOffset % 60);
			if (timeZoneHours.length == 1) {
				timeZoneHours = "0" + timeZoneHours;
			}
			if (timeZoneMinutes.length == 1) {
				timeZoneMinutes = "0" + timeZoneMinutes;
			}
			return myDate.getFullYear() + "-" + month + "-" + day + "T" + hour + ":" + minute + ":" + second + ".0000000-" + timeZoneHours + ":" + timeZoneMinutes;
		}
		else {
			return null;
		}
	}

	public stripOutCrap(something: any) {
		if (something) {
			for (var field in something) {
				if (field.indexOf('<') >= 0) {
					something[field.substring(field.indexOf('<') + 1, field.indexOf('>'))] = something[field];
					delete something[field];
				}
			}
		}
	}


	public getCanceller() {
		return this.$q.defer<null>(); 
	}

	public cancelCanceller(canceller: angular.IDeferred<null>) {
		if (canceller) {
			canceller.resolve();
		}
	}

	public getCancellerConfig(config: angular.IRequestShortcutConfig, canceller: angular.IDeferred<null>) {
		config = config || {};
		if (canceller) {
			config.timeout = canceller.promise; 
		}
		return config; 
		
	}

	public isCancelled(error: any) {
		return error && error.xhrStatus === "abort";
	}

}

export class AtonixRedirector {
	constructor(private $window: angular.IWindowService, private $log: angular.ILogService, private $location: angular.ILocationService, private atonixAuthService: AtonixAuthenticationService) {

	}

	public RedirectToLogin(config?: { url:string}) {
		this.atonixAuthService.GoToAuthUrl(this.$location.absUrl())
		if (this.$log && this.$log.info) {
			var url = "";
			if (config && config.url) {
				url = config.url;
			}
			if (this.$window && this.$window.localStorage && this.$window.localStorage['accessToken']) { url += " (access token defined)" }
			else { url += " (access token undefined)" }
			this.$log.info("Unauthorized access to resource " + url + ", redirecting to login page");
		}
	}

	public RedirectToNotAllowed(config?: { url: string }) {
		this.$window.location.href = '/NotAllowed.html';
		if (this.$log && this.$log.info) {
			var url = "";
			if (config && config.url) {
				url = config.url;
			}
			if (this.$window && this.$window.localStorage && this.$window.localStorage['accessToken']) { url += " (access token defined)" }
			else { url += " (access token undefined)" }
			this.$log.info("Forbidden access to resource " + url + ", redirecting to home page");
		}
	}

	public RedirectToExpired(config?: { url: string }, username?: string, err_description?: string) {
		let url = this.$location.absUrl();
		if (config && config.url) {
			url = config.url;
		}

		//The user must change their password so this should redirect them to the password form.
		var p = '/Account/Index.html#!/Password';
		if (url) {
			p = p + '?username=' + encodeURIComponent(username) + '&returnUrl=' + encodeURIComponent(url) + '&passwordExpire=1&passwordExpiredMsg=' + err_description;
		}

		this.$window.location.href = p;
		if (this.$log && this.$log.info) {
			if (this.$window && this.$window.localStorage && this.$window.localStorage['accessToken']) { url += " (access token defined)" }
			else { url += " (access token undefined)" }
			this.$log.info("User Expired " + url + ", redirecting to account page");
		}
	}
}

export class AtonixRequestBuffer {

	constructor(private $q: angular.IQService, private atonixAuthenticationService: AtonixAuthenticationService) {

	}

	private isRequestAnonymous(req: angular.IRequestConfig) {
		let result: boolean = false;
		if (req.headers['Anonymous']) {
			result = true;
		}
		return result;
	}

	private applyToken(req: angular.IRequestConfig, token:string) {		
		req.headers.Authorization = 'Bearer ' + token;
	}

	public StoreRequest(req: angular.IRequestConfig) {
		let result: angular.IDeferred<angular.IRequestConfig> = this.$q.defer();

		this.atonixAuthenticationService.GetToken()
			.then((t) => {
				this.applyToken(req, t);
				result.resolve(req); 
			})
			.catch((e) => {
				if (this.isRequestAnonymous(req)) {
					result.resolve(req);
				}
				else {
					result.reject({ message: "Not Logged In", status: 401 });
				}
			});

		return result.promise; 
	}

	private isTesting: boolean = false;
	public ConfigureTesting() {
		this.isTesting = true;
	}
}


//This will look at all of the error responses from the $http object and if a 401-Not Authorized error is
//returned the user will be redirected to the login page.  Once the user logs in he will be automagically redirected
//back to the previous page.
export class AuthInterceptor implements ng.IHttpInterceptor {
	constructor(private $q: ng.IQService, private atonixRedirector: AtonixRedirector, private atonixRequestBuffer: AtonixRequestBuffer) {
		let myInstance = this;
		this.request = (config) => { return myInstance.requestMethod(config); };
		this.requestError = (rejection) => { return myInstance.requestErrorMethod(rejection); };
		this.response = (response) => { return myInstance.responseMethod(response); };
		this.responseError = (rejection) => { return myInstance.responseErrorMethod(rejection);  };
	}

	public request: (config: angular.IRequestConfig) => angular.IRequestConfig | angular.IPromise<angular.IRequestConfig>;
	public requestError: (rejection: any) => any;
	public response: <T>(response: angular.IHttpPromiseCallbackArg<T>) => angular.IPromise<angular.IHttpPromiseCallbackArg<T>> | angular.IHttpPromiseCallbackArg<T>;
	public responseError: (rejection: any) => any;



	public requestMethod(config: angular.IRequestConfig) {
		let r = this.atonixRequestBuffer.StoreRequest(config);
		return r;
	}


	public requestErrorMethod(rejection: any) {
		return rejection;
	}

	public responseMethod<T>(response: angular.IHttpPromiseCallbackArg<T>) {
		return response;
	}

	public responseErrorMethod(rejection: any) {
		let result: angular.IPromise<any> = this.$q.reject(rejection); 

		if (window && window['isLoginPage']) {
			console.log("Skipping redirect on login page. ");
		}
		else if (rejection.status === 401) {
			//We grab the error here and dont pass it along.  If the application is redirecting anyway
			//there is no reason to pass the 401 or 403 along to the calling function
			console.log("User not logged in, redirecting to login page.");
			result = this.$q.defer().promise; 
			this.atonixRedirector.RedirectToLogin(rejection.config);
		}
		else if (rejection.status === 403) {
			console.log("User permission denied, redirecting to access denied page.");
			result = this.$q.defer().promise; 
			this.atonixRedirector.RedirectToNotAllowed(rejection.config); 
		}
		return result;
	}
}

export enum AtonixAuthenticationConstants {
	LoginSuccessful,
	MFARequired,
	TotpRequired,
	PasswordChangeRequired,
	LoginFailed,
	ChangeSuccessful,
	VerificationCodeRequired,
	InitialPasswordRequired,
	NotImplemented
}

export class AtonixAuthenticationService {
	private userpool: cognito.CognitoUserPool;
	private user: cognito.CognitoUser;
    private session: cognito.CognitoUserSession;

	constructor(public $q: angular.IQService, private $window: angular.IWindowService) {

		this.Initialize(); 
	}

	//This is only ever really called in the Unauthorized app after the pool ID and client ID are retrieved from the server. 
	public Initialize() {
		if (this.isCognitoInformationLoaded()) {
			if (!this.populateUser(false)) {
				this.populateUser(true);
			}
		}
	}
	 
	public getSessionWithToken(tokenString?: string) {
		var deferred = this.$q.defer <boolean>();
		if (tokenString) {
			const tokens: any = JSON.parse(tokenString);
			if (tokens && tokens.refresh_token && tokens.id_token) {
				const token = jwt(tokens.id_token);

				let poolData = this.getPoolData();
				let userpool = new cognito.CognitoUserPool(poolData);

				const data: cognito.ICognitoUserData = {
					Username: token['cognito:username'],
					Pool: userpool
				};
				let user = new cognito.CognitoUser(data);

				var rt = new cognito.CognitoRefreshToken({ RefreshToken: tokens.refresh_token });
				user.refreshSession(rt, (err, session) => {
					if (err) {
						deferred.resolve(false);
					}
					else {
						this.userpool = userpool;
						this.user = user;
						this.session = session;
						deferred.resolve(true);
					}
				});
			}
			else {
				deferred.resolve(false);
			}
		}
		else {
			deferred.resolve(false); 
		}
		return deferred.promise;
	}

	public GetCognitoAuthURL(clientID:string,hostedUI:string, statevalue: string) {
		let redirectURL = '';
		if (window && window.location.host && window.location.protocol) {
			redirectURL = window.location.protocol + "//" + window.location.host;
		}

		redirectURL += "/Unauthorized.html";
		let url = hostedUI + "/login?response_type=code&client_id=" + clientID + "&redirect_uri=" + redirectURL + "&state=" + statevalue;

		return url; 
	}

	public GetUnauthorizedURL(statevalue?: string) {
		let result = "/Unauthorized.html";
		if (statevalue) {
			result = result + "?state=" + statevalue; 
		}
		return result;
	}

	public SaveCallbackUrlInStorage(callback?: string) {
		let id = String(Math.floor(  Math.random() * 10000));
		window.localStorage.setItem("REDIRECTSTATE:" + id, callback || '');
		return id; 
	}

	public getCognitoSettings() {
		
		var deferred: ng.IDeferred<{ ClientID: string, HostedUI: string }> = this.$q.defer();

		let clientID = this.ClientID();
		let hostedUI = this.HostedUI(); 
		if (clientID && hostedUI) {
			deferred.resolve({ ClientID: clientID, HostedUI: hostedUI });
		}
		else {
			let url = "/Services/api/Authorization/CognitoSettings"

			$.getJSON(url).done((data) => {
				if (data.ClientID) {
					this.ClientID(data.ClientID);
				}
				if (data.HostedUI) {
					this.HostedUI(data.HostedUI);
				}

				deferred.resolve(data);
			}).fail((err) => {
				deferred.reject(err);
			});
		}
			
		return deferred.promise;
	}

	public GoToAuthUrl(callback?: string) {
		let statevalue = this.SaveCallbackUrlInStorage(callback);

		this.getCognitoSettings().then(settings => {
			if (window && window.location) {
				// These commented out lines may be necessary if we ever turn hosted UI on again. 
				// if (settings.ClientID) {
				//	window.location.href = this.GetCognitoAuthURL(settings.ClientID, settings.HostedUI, statevalue);
				// }
				// else {
					window.location.href = this.GetUnauthorizedURL(statevalue);
				// }

			}
		}).catch(error => {
			console.error('The cognito settings were not found. ');
			window.location.href = this.GetUnauthorizedURL(statevalue);
		});

	}

	private getPoolData() {
		let poolData: cognito.ICognitoUserPoolData = {
			UserPoolId: this.UserPoolID(),
			ClientId: this.ClientID()
		};
		return poolData; 
	}

	private populateUser(useSession: boolean = false) {
		let result: boolean = false; 

		let poolData = this.getPoolData(); 

		//If the user has unchecked remember me this should use session storage instead of local storage.  
		if (useSession) {
			poolData.Storage = this.$window.sessionStorage; 
		}

		this.userpool = new cognito.CognitoUserPool(poolData);
		this.user = this.userpool.getCurrentUser();
		if (this.user && this.user.getSession) {
			result = true; 
			this.session = this.user.getSession((err, s) => {
				if (!err) {
					this.session = s;
					this.attributes = null;
				}
			});
		}
		return result; 
	}

	public isCognitoInformationLoaded() {
		if (this.ClientID() && this.UserPoolID()) {
			return true; 
		}
		return false; 
	}

	public HostedUI(newVal?: string) {
		if (!_.isUndefined(newVal)) {
			window.localStorage.setItem("Cognito_HostedUI", newVal);
		}
		return window.localStorage.getItem("Cognito_HostedUI") || null;
	}

	public UserPoolID(newVal?: string) {
		if (!_.isUndefined(newVal)) {
			window.localStorage.setItem("Cognito_UserPoolID", newVal);
		}
		return window.localStorage.getItem("Cognito_UserPoolID") || null;
	}

	public ClientID(newVal?: string) {
		if (!_.isUndefined(newVal)) {
			window.localStorage.setItem("Cognito_ClientID", newVal);
		}
		return window.localStorage.getItem("Cognito_ClientID") || null;
	}

	public AuthFlowType(newVal?: string) {
		if (!_.isUndefined(newVal)) {
			window.localStorage.setItem("Cognito_AuthFlowType", newVal);
		}
		return window.localStorage.getItem("Cognito_AuthFlowType") || null;
	}

	private attributes: cognito.CognitoUserAttribute[];

	private getAttribute(attributeName) {
		let deferred = this.$q.defer<string>();

		let value: string = "";

		if (this.attributes) {
			for (let i: number = 0; i < this.attributes.length; i++) {
				if (this.attributes[i].getName() === attributeName) {
					value = this.attributes[i].getValue();
					break;
				}
			}
			deferred.resolve(value);
		}
		else {
			this.user.getUserAttributes((err, result) => {
				if (err) {
					deferred.reject(err);
				}
				else {
					this.attributes = result; 
					for (let i: number = 0; i < result.length; i++) {
						if (result[i].getName() === attributeName) {
							value = result[i].getValue();
							break;
						}
					}
					deferred.resolve(value);
				}
			});
		}

		return deferred.promise;
	}

	public FriendlyName() {
		return this.getAttribute('name'); 
	}

	public Email() {
		return this.getAttribute('email');
	}

	public PhoneNumber() {
		return this.getAttribute('phone_number'); 
	}

	public PhoneNumberVerified() {
		return this.getAttribute('phone_number_verified').then((result) => {
			let pnv: boolean = (result === 'true'); 
			return pnv; 
		});
	}

	public SetPhoneNumber(phoneNumber: string) {
		let deferred = this.$q.defer<{ Status: AtonixAuthenticationConstants }>();
		this.attributes = null;

		var attributeList = [];
		var attribute = new cognito.CognitoUserAttribute({
			Name: 'phone_number',
			Value: phoneNumber
		});
		attributeList.push(attribute); 

		this.user.updateAttributes(attributeList, (err, result) => {
			if (err) {
				deferred.reject(err);
			}
			else {
				this.user.getAttributeVerificationCode("phone_number", {
					onSuccess: () => {
						deferred.resolve({ Status: AtonixAuthenticationConstants.ChangeSuccessful });
					},
					onFailure: (err2) => {
						deferred.reject(err2); 
					},
					inputVerificationCode: () => {
						deferred.resolve({
							Status: AtonixAuthenticationConstants.VerificationCodeRequired
						});
					}
				});
			}
		});

		return deferred.promise;
	}

	public ResendPhoneVerificationCode() {
		let deferred = this.$q.defer<{ Status: AtonixAuthenticationConstants }>();

		this.user.getAttributeVerificationCode("phone_number", {
			onSuccess: () => {
				deferred.resolve({ Status: AtonixAuthenticationConstants.ChangeSuccessful });
			},
			onFailure: (err2) => {
				deferred.reject(err2);
			},
			inputVerificationCode: () => {
				deferred.resolve({
					Status: AtonixAuthenticationConstants.VerificationCodeRequired
				});
			}
		});

		return deferred.promise;
	}

	public VerifyPhone(code:string) {
		let deferred = this.$q.defer();

		this.user.verifyAttribute("phone_number", code, {
			onSuccess: () => {
				deferred.resolve(); 
			},
			onFailure: (err) => {
				deferred.reject(err); 
			}
		});

		return deferred.promise; 
	}

	public IsLoggedIn() {
		let result: boolean = false;
		if (this.user) {
			result = true;
		}
		return result;
	}

	public IsUserFederated()
	{
		return this.GetToken().then(token => {
			let result: boolean = false;
			const info = jwt(token);
			if (info && info.identities && info.identities.length > 0) {
				let allSAML: boolean = true; 
				for (let identity of info.identities) {
					if (identity.providerType !== 'SAML') {
						allSAML = false; 
					}
				}
				result = allSAML; 
			}
			return result; 
		});
	}

	public GetAccessToken() {
		let deferred = this.$q.defer<string>()
		this.attributes = null;

		if (this.session) {
			if (this.session.isValid()) {
				let t = this.session.getAccessToken().getJwtToken();
				deferred.resolve(t);
			}
			else {
				this.user.refreshSession(this.session.getRefreshToken(), (err, session) => {
					if (err) {
						deferred.reject("Could not refresh user.");
					}
					else {
						this.session = session;
						let t = this.session.getAccessToken().getJwtToken();
						deferred.resolve(t);
					}
				});
			}

		}
		else if (this.user) {
			this.user.getSession((err, session) => {
				if (err) {
					deferred.reject("Could not get user.");
				}
				else {
					this.session = session;
					deferred.resolve(this.session.getAccessToken().getJwtToken());
				}
			});
		}
		else {
			deferred.reject("Not Logged In");
		}

		return deferred.promise;
	}

	public GetToken() {
		let deferred = this.$q.defer<string>()
		this.attributes = null;

		if (this.session) {
			if (this.session.isValid()) {
				let t = this.session.getIdToken().getJwtToken();
				deferred.resolve(t);
			}
			else {
				this.user.refreshSession(this.session.getRefreshToken(), (err, session) => {
					if (err) {
						deferred.reject("Could not refresh user.");
					}
					else {
						this.session = session;
						let t = this.session.getIdToken().getJwtToken();
						deferred.resolve(t);
					}
				});
			}

		}
		else if (this.user) {
			this.user.getSession((err, session) => {
				if (err) {
					deferred.reject("Could not get user.");
				}
				else {
					this.session = session;
					deferred.resolve(this.session.getIdToken().getJwtToken());
				}
			});
		}
		else {
			deferred.reject("Not Logged In");
		}

		return deferred.promise;
	}

	public SignUp(email: string, name: string, phoneNumber: string, password: string) {
		let deferred = this.$q.defer<cognito.ISignUpResult>();
		email = email.toLowerCase(); 

		this.attributes = null;
		let attributeList = [];
		let dataEmail: cognito.ICognitoUserAttributeData = {
			Name: 'email',
			Value: email
		};
		let dataPhoneNumber: cognito.ICognitoUserAttributeData = {
			Name: 'phone_number',
			Value: phoneNumber
		};

		let dataName: cognito.ICognitoUserAttributeData = {
			Name: 'name',
			Value: name
		};

		let attributeEmail = new cognito.CognitoUserAttribute(dataEmail);
		let attributePhoneNumber = new cognito.CognitoUserAttribute(dataPhoneNumber);
		let attributeName = new cognito.CognitoUserAttribute(dataName);
		attributeList.push(attributeEmail);
		attributeList.push(attributePhoneNumber);
		attributeList.push(attributeName);

		this.userpool.signUp(email, password, attributeList, null, (err, result) => {
			if (err) {
				deferred.reject(err);
			}
			else {
				this.user = result.user;
				deferred.resolve(result);
			}
		});

		return deferred.promise;

	}

	public ConfirmUser(key: string) {
		let deferred = this.$q.defer<boolean>();
		this.attributes = null;
		if (this.user) {
			this.user.confirmRegistration(key, true, (err, result) => {
				if (err) {
					deferred.reject(err);
				}
				else {
					deferred.resolve(true);
				}
			});
		}
		else {
			deferred.reject({ message: "No User" });
		}

		return deferred.promise;
	}

	private CreateUser(email: string, rememberMe:boolean = true) {
		email = email.toLowerCase(); 

		let userData: cognito.ICognitoUserData = {
			Username: email,
			Pool: this.userpool
		};

		if (!rememberMe) {
			userData.Storage = this.$window.sessionStorage; 
		}

		this.$window.localStorage.setItem('user', JSON.stringify({ 'Email':email })); 

		return new cognito.CognitoUser(userData);
	}

	public ConfigureMFAWithSMS() {
		let totpMfaSettings = null;
		let smsMfaSettings = {
			PreferredMfa: true,
			Enabled: true
		};

		let deferred = this.$q.defer();
		this.user.enableMFA((err,s) => {
			if (err) {
				deferred.reject(err);
			}
			else {
				

				(<any>this.user).setUserMfaPreference(smsMfaSettings, totpMfaSettings, (err2, result) => {
					if (err2) {
						deferred.reject(err2);
					}
					else {
						deferred.resolve();
					}
				});
			}
		});

		return deferred.promise;
	}

	public ConfigureMFAWithTOTP() {


		let deferred = this.$q.defer<string>();

		this.user.associateSoftwareToken({
			associateSecretCode: (secretCode: string) => {
				deferred.resolve(secretCode);
			},
			onFailure: (err3: any) => {
				deferred.reject(err3);
			}
		});	




		return deferred.promise; 
	}

	public VerifyMFAWithTOTP(code: string) {
		let totpMfaSettings = {
			PreferredMfa: true,
			Enabled: true
		};
		let smsMfaSettings = null;

		let deferred = this.$q.defer();
		let deviceName: string = undefined; 

		this.user.verifySoftwareToken(code, deviceName, {
			onSuccess: (session) => {
				this.session = session; 
				this.user.enableMFA((err, s) => {
					if (err) {
						deferred.reject(err);
					}
					else {
						(<any>this.user).setUserMfaPreference(smsMfaSettings, totpMfaSettings, (err2, result) => {
							if (err2) {
								deferred.reject(err2);
							}
							else {
								deferred.resolve(); 
							}
						});
					}
				});
			},
			onFailure: (err) => {
				deferred.reject(err); 
			}
		});

		return deferred.promise; 
	}

	public DisableMFA() {
		let deferred = this.$q.defer();

		let smsMfaSettings = {
			Enabled: false,
			PreferredMfa:false
		};
		let totpMfaSettings = {
			Enabled: false, 
			PreferredMfa:false 
		};

		
		//Annoyingly, if the user does not have one of these configured it will throw an error. 
		//In that case I need to resend the request leaving out the appropriate value.  
		(<any>this.user).setUserMfaPreference(smsMfaSettings, totpMfaSettings, (err: {code:string, message:string, name:string}, result) => {
			if (err) {
				if (err.name == "InvalidParameterException") {
					(<any>this.user).setUserMfaPreference(smsMfaSettings, null, (err2: { code: string, message: string, name: string }, result) => {
						if (err2) {
							console.error("Could not disable MFA.");
							deferred.reject(err);
						}
						else {
							deferred.resolve(); 
						}
					});
				}
			}
			else {
				deferred.resolve();
			}
		});

		return deferred.promise;
	}

	public Login(email: string, password: string, rememberMe: boolean = true) {
		let deferred = this.$q.defer<{ Status: AtonixAuthenticationConstants, Challenge?:string, ChallengeParameters?:string, UserAttributes?:any, RequiredAttributes?:any }>();

		email = email.toLowerCase(); 

		let authenticationData: cognito.IAuthenticationDetailsData = {
			Username: email,
			Password: password			
		};
		
		let authenticationDetails = new cognito.AuthenticationDetails(authenticationData);
		
		this.user = this.CreateUser(email, rememberMe);
		// The CognitoUser function from amazon-cognito-auth-js sets the authentication flow type to USER_SRP_AUTH. This is
		// appropriate for normal use. However, to migrate users to a different pool without requiring a password reset,
		// the non-SRP USER_PASSWORD_AUTH flow type must be used. This flow type permits the user pool to trigger a Lambda
		// function that verifies the account using the supplied password and migrates it to a different pool. The OLD
		// and NEW user pools must be configured properly in Cognito for this to work. Relevant settings are identified below.
		// 27-Jan-2021 RMB

		// Cognito > User Pools > [User Pool] > General settings > App clients > Asset360 > Auth Flows Configuration
		//   OLD User Pool --> ALLOW_ADMIN_USER_PASSWORD_AUTH = true
		//   NEW User Pool --> ALLOW_USER_PASSWORD_AUTH = true

		// Cognito > User Pools > [NEW User Pool] > General settings > Triggers	> User Migration
		//   Lambda function --> [stack]-cognito-forgot-password

		this.user.setAuthenticationFlowType(this.AuthFlowType());

		this.user.authenticateUser(authenticationDetails, {
			onSuccess: (result) => {
				this.session = result;

				deferred.resolve({ Status: AtonixAuthenticationConstants.LoginSuccessful });
			},
			onFailure: (err) => {
				if (err.code === "PasswordResetRequiredException") {
					deferred.resolve({ Status: AtonixAuthenticationConstants.PasswordChangeRequired });
				}
				else {
					deferred.reject(err);
				}
			},
			mfaRequired: (codeDeliveryDetails) => {
				deferred.resolve({ Status: AtonixAuthenticationConstants.MFARequired });
			},
			totpRequired: (challengeName: any, challengeParameters: any) => {
				deferred.resolve({
					Status: AtonixAuthenticationConstants.TotpRequired,
					Challenge: challengeName,
					ChallengeParameters: challengeParameters
				});
			},
			newPasswordRequired: (userAttributes: any, requiredAttributes: any) => {
				deferred.resolve({
					Status: AtonixAuthenticationConstants.InitialPasswordRequired,
					UserAttributes: userAttributes,
					RequiredAttributes:requiredAttributes
				});
			}
		});

		return deferred.promise;

	}

	public CompleteInitialPassword(newPassword: string, attributesData: { name: string }) {
		let deferred = this.$q.defer<{ Status: AtonixAuthenticationConstants, Challenge?: string, ChallengeParameters?: string }>();

		this.user.completeNewPasswordChallenge(newPassword, attributesData, {
			onSuccess: (session: cognito.CognitoUserSession) => {
				this.session = session;
				deferred.resolve({ Status: AtonixAuthenticationConstants.LoginSuccessful });
			},
			onFailure: (err) => {
				if (err.code === "PasswordResetRequiredException") {
					deferred.resolve({ Status: AtonixAuthenticationConstants.PasswordChangeRequired });
				}
				else {
					deferred.reject(err);
				}
			},
			mfaRequired: (codeDeliveryDetails) => {
				deferred.resolve({ Status: AtonixAuthenticationConstants.MFARequired });
			}
		});

		return deferred.promise; 
	}

	public LogOut() {
		if (this.user) {
			this.user.signOut();
			this.user = null; 
		}
		this.session = null;
	}

	public FinishLoginSMS(code: string) {
		let deferred = this.$q.defer<{ Status: AtonixAuthenticationConstants }>();

		this.user.sendMFACode(code, {
			onSuccess: (result) => {
				this.session = result;
				deferred.resolve({ Status: AtonixAuthenticationConstants.LoginSuccessful });
			},
			onFailure: (err) => {
				deferred.reject(err);
			}
		}, "SMS_MFA");

		return deferred.promise;
	}

	public FinishLoginSoftwareToken(code: string) {
		let deferred = this.$q.defer<{ Status: AtonixAuthenticationConstants }>();

		this.user.sendMFACode(code, {
			onSuccess: (result) => {
				this.session = result;
				deferred.resolve({ Status: AtonixAuthenticationConstants.LoginSuccessful });
			},
			onFailure: (err) => {
				deferred.reject(err);
			}
		}, "SOFTWARE_TOKEN_MFA");

		return deferred.promise;
	}

	public ForgotPassword(email: string) {
		let deferred = this.$q.defer<{AttributeName:string, DeliveryMedium:string, Destination:string}>();

		email = email.toLowerCase(); 

		this.user = this.CreateUser(email);

		this.user.forgotPassword({
			onSuccess: (data: any) => {

				deferred.resolve(data);
			},
			onFailure: (err: {code:string, message:string, name:string}) => {
				deferred.reject(err);
			},
			inputVerificationCode: (data: { CodeDeliveryDetails: { AttributeName: string, DeliveryMedium: string, Destination: string } }) => {
				deferred.resolve(data.CodeDeliveryDetails); 
			}
		});

		return deferred.promise;
	}

	public ChangePassword(oldPassword: string, newPassword: string) {
		let deferred = this.$q.defer();

		this.user.changePassword(oldPassword, newPassword, (err, result) => {
			if (err) {
				console.error("Could not change password.");
				deferred.reject(err);
			}
			else {
				deferred.resolve(); 
			}
		});

		return deferred.promise;
	}

	public ConfirmPassword(email:string,  newPassword: string, verificationCode: string) {
		let deferred = this.$q.defer();

		email = email.toLowerCase(); 

		this.user = this.CreateUser(email);

		this.user.confirmPassword(verificationCode, newPassword, {
			onSuccess: () => {
				deferred.resolve();
			},
			onFailure: (err) => {
				deferred.reject(err);
			}
		});

		return deferred.promise;
	}
}

export class AtonixLocalAuthenticationService {
	private storage: Storage; 
	private axUser: model.IUser = null; 
	private token: string = null; 

	constructor(public $q: angular.IQService, private $window: angular.IWindowService) {
		let isSession: boolean = false; 

		let settings: string = $window.localStorage.getItem("AtonixLocalAuthenticationServiceSettings");

		if (!settings || settings === 'undefined' || settings === 'null') {
			settings = $window.sessionStorage.getItem("AtonixLocalAuthenticationServiceSettings");
			isSession = true; 
		}

		if (settings) {
			let settingsObject = JSON.parse(settings);
			this.axUser = settingsObject.User; 
			this.token = settingsObject.Token; 

			if (isSession) {
				this.storage = this.$window.sessionStorage;
			}
			else {
				this.storage = this.$window.localStorage;
			}

		}
	}

	public FriendlyName() {
		let result: string = null; 
		if (this.axUser) {
			result = this.axUser.FirstName + " " + this.axUser.LastName; 
		}
		return this.$q.resolve(result);
	}

	public Email() {
		let result: string = null;
		if (this.axUser) {
			result = this.axUser.Email;
		}
		return this.$q.resolve(result);
	}

	public PhoneNumber() {
		return this.$q.resolve("");
	}

	public PhoneNumberVerified() {
		return this.$q.resolve(false); 
	}

	public SetPhoneNumber(phoneNumber: string) {
		return this.$q.resolve({ Status: AtonixAuthenticationConstants.NotImplemented });
	}

	public ResendPhoneVerificationCode() {
		return this.$q.resolve({ Status: AtonixAuthenticationConstants.NotImplemented });
	}

	public VerifyPhone(code: string) {
		return this.$q.resolve(); 
	}

	public IsLoggedIn() {
		let result: boolean = false;
		if (this.token) {
			result = true;
		}
		return result;
	}

	public GetToken() {
		if (this.token) {
			return this.$q.resolve(this.token);
		}
		else {
			return this.$q.reject("User Not Logged In"); 
		}
	}

	public SignUp(email: string, name: string, phoneNumber: string, password: string) {
		return this.$q.reject("Can Not Sign Up"); 
	}

	public ConfirmUser(key: string) {
		return this.$q.reject("Can Not Confirm User"); 
	}

	public ConfigureMFAWithSMS() {
		return this.$q.reject("Can Not Configure MFA with SMS"); 
	}

	public ConfigureMFAWithTOTP() {
		return this.$q.reject("Can Not Configure MFA with TOTP"); 
	}

	public VerifyMFAWithTOTP(code: string) {
		return this.$q.reject("Can Not Verify MFA with TOTP"); 
	}

	public DisableMFA() {
		return this.$q.resolve(); 
	}

	public Login(email: string, password: string, rememberMe: boolean = true) {
		let deferred = this.$q.defer<{ Status: AtonixAuthenticationConstants, Challenge?: string, ChallengeParameters?: string, UserAttributes?: any, RequiredAttributes?: any }>();

		var d = 'grant_type=password&username=' + email + '&password=' + encodeURIComponent(password);

		//This is a login so clear all caches and completely forget you are logged in.  
		this.token = null; 

		//this.$http.post<{ access_token: string }>('/Services/Token', d,
		$.post('/Services/Token', d)
			.done((result) => {
				this.token = result.access_token;
				//If the login is successful then remember the access token and get the user info. 
				if (rememberMe) {
					this.storage = this.$window.localStorage;
				}
				else {
					this.storage = this.$window.sessionStorage; 
				}
				let settingsObject = {
					User: { Email: email },
					Token:this.token}; 

				this.storage.setItem("AtonixLocalAuthenticationServiceSettings", JSON.stringify(settingsObject));
				this.storage.setItem('user', JSON.stringify( { email: email }));
				deferred.resolve({ Status: AtonixAuthenticationConstants.LoginSuccessful });
			})
			.fail((data) => {
				deferred.reject(data); 
			});
			

		return deferred.promise;

	}

	public CompleteInitialPassword(newPassword: string, attributesData: { name: string }) {
		return this.$q.reject("Not Supported"); 
	}

	public LogOut() {
		if (this.storage) {
			this.storage.clear();
		}
		this.token = null;
		this.axUser = null; 
		this.storage = null; 
	}

	public FinishLoginSMS(code: string) {
		return this.$q.reject("Not Supported"); 
	}

	public FinishLoginSoftwareToken(code: string) {
		return this.$q.reject("Not Supported"); 
	}

	public ForgotPassword(email: string) {
		this.$q.reject("Not Supported"); 
	}

	public ChangePassword(oldPassword: string, newPassword: string) {
		this.$q.reject("Not Supported"); 
	}

	public ConfirmPassword(email: string, newPassword: string, verificationCode: string) {
		this.$q.reject("Not Supported"); 
	}


}


export var modelModule: angular.IModule = angular.module('model', ['ngCookies']);

modelModule.factory('AtonixAuthenticationService', ['$q','$window', ($q,$window) => new AtonixAuthenticationService($q,$window)]);
//modelModule.factory('AtonixAuthenticationService', ['$q', '$window', ($q, $window) => new AtonixLocalAuthenticationService($q, $window)]);

modelModule.factory('AtonixRedirector', ['$window', '$log', '$location', 'AtonixAuthenticationService', ($window, $log, $location, atonixAuthenticationService) => new AtonixRedirector($window, $log, $location, atonixAuthenticationService)]);
modelModule.factory('AtonixRequestBuffer', ['$q', 'AtonixAuthenticationService', ($q, AtonixAuthenticationService) => new AtonixRequestBuffer($q, AtonixAuthenticationService)]);

modelModule.factory('baseModel', ['$window', '$http', '$cookies', 'AtonixAuthenticationService', '$q', '$log', ($window, $http, $cookies, atonixAuthenticationService, $q, $log) => new BaseModel($window, $http, $cookies, atonixAuthenticationService, $q, $log)]);

modelModule.factory('authInterceptor', ['$q', 'AtonixRedirector', 'AtonixRequestBuffer', ($q, AtonixRedirector, AtonixRequestBuffer) => new AuthInterceptor($q, AtonixRedirector,AtonixRequestBuffer)]);

modelModule.config(['$httpProvider', function ($httpProvider: ng.IHttpProvider) {
	
	$httpProvider.interceptors.push('authInterceptor');
}]);


// WEBPACK FOOTER //
// ./Common/Models/model.ts